import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { STARTER_API } from '../ApiNames'
import { LoginService } from '../services/LoginService'
import { Toast } from 'primereact/toast';
import './Register.css';

var imageName = require('./../assets/img/mdcal.png');

export const Register = () => {
    const useroptions = [
        { label: 'Doctor', value: 'DOCTOR' },
        { label: 'Patient', value: 'PATIENT' },
    ];
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');

    const [email, setemail] = useState('');
    const [password, setpassword] = useState('');
    const [phone, setphone] = useState('');
    const [usertype, setUserType] = useState('');
    const toast = useRef<Toast | null>(null);
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };
    const hanleRegister = async () => {
          if (!isChecked) {
        toast.current?.show({
            severity: 'warn',
            detail: 'Please agree to the terms before signing up.',
            life: 3000
        });
        return;
    }
        if (!firstname || !lastname || !password || !email || !usertype) {
            toast.current?.show({
                severity: 'error',
                detail: 'Please fill in all required fields.',
                life: 3000
            });
            return;
        }
        try {
            const payload = { firstname: firstname, lastname: lastname, email: email, usertype: usertype, password: password };
            const apiname = STARTER_API.register_API;
            const data = await LoginService.getData(apiname, payload);
            if (data === 'Registered successfuly!') {
                if (toast.current) {
                    toast.current.show({ severity: 'success', detail: data });
                }
            } else {
                if (toast.current) {
                    toast.current.show({ severity: 'info', detail: data });
                }
            }
            setFirstname('');
            setLastname('');
            setemail('');
            setpassword('');
            setUserType('');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
//     const hanleRegister = async () => {

//     // 🚫 TERMS NOT ACCEPTED → STOP HERE
//     if (!isChecked) {
//         toast.current?.show({
//             severity: 'warn',
//             summary: 'Terms Required',
//             detail: 'Please accept the Terms & Conditions before signing up.',
//             life: 3000
//         });
//         return; // ⛔ IMPORTANT
//     }

//     // 🚫 REQUIRED FIELDS CHECK
//     if (!firstname || !lastname || !password || !email || !usertype) {
//         toast.current?.show({
//             severity: 'error',
//             summary: 'Missing Fields',
//             detail: 'Please fill in all required fields.',
//             life: 3000
//         });
//         return;
//     }

//     try {
//         const payload = {
//             firstname,
//             lastname,
//             email,
//             usertype,
//             password
//         };

//         const apiname = STARTER_API.register_API;
//         const data = await LoginService.getData(apiname, payload);

//         toast.current?.show({
//             severity: data === 'Registered successfuly!' ? 'success' : 'info',
//             detail: data,
//             life: 3000
//         });

//     } catch (error) {
//         console.error('Error fetching data:', error);
//     }
// };

    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/sup-login.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-body flex justify-content-center align-items-center" style={{ flexDirection: 'column', minHeight: '100vh' }}>
            <div className="w-full flex justify-content-end mb-3">
  <a
    title="Help"
    onClick={(e) => openWindow(e, IUrl)}
    style={{
      color: "blue",
      fontSize: 15,
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px"
    }}
  >
    Help for this Page
    <i
      className="pi pi-question-circle"
      style={{
        backgroundColor: "orange",
        color: "white",
        borderRadius: "50%",
        padding: "3px"
      }}
    ></i>
  </a>
</div>

            {/* Logo Section */}
            <div className="logo-container mb-4" style={{ display: 'flex', justifyContent: 'center', minWidth: '220px' }}>
                <img src={imageName} alt="Logo" width="220px" style={{ width: '320px' }} />
            </div>

            {/* Login Box */}
            
            <div className="surface-card p-4 shadow-2 border-round w-full lg:w-4">
                

                <div className="text-center mb-5">
                    <div className="text-900 text-3x font-medium mb-3">
                        <h2 style={{ color: 'rgb(102, 102, 102)', fontSize: '20px', fontWeight: '400' }}>
                            Register a new membership
                        </h2>
                    </div>
                </div>
                <div>
                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" value={firstname} placeholder="Enter First Name" className="w-full" onChange={(e) => setFirstname(e.target.value)}
                        />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" value={lastname} placeholder="Enter Last Name" className="w-full" onChange={(e) => setLastname(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <Dropdown value={usertype} options={useroptions} onChange={(e) => setUserType(e.value)} optionLabel="label" optionValue="value" placeholder="Select a User" className="w-full custom-dropdown" />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-users" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="email" type="text" value={email} placeholder="Enter Email" className="w-full" onChange={(e) => setemail(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-envelope" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="password" type="password" value={password} placeholder="Enter Password" className="w-full" onChange={(e) => setpassword(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-lock" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input type="checkbox" id="remember" checked={isChecked} onChange={handleCheckboxChange} style={{ marginRight: '10px' }} />
                            <label htmlFor="terms" className="p-checkbox-label"><span style={{ color: 'rgb(102, 102, 102)', fontWeight: '900', fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol', fontSize: '18px' }}>I agree to the terms</span></label>
                        </div>

                        <Button label="Sign Up" style={{ backgroundColor: 'rgb(0, 105, 217)', marginTop: '20px', color: '#fff' }} icon="pi pi-user" onClick={hanleRegister} text raised />
                    </div>
                    <div style={{ textAlign: 'left', marginTop: '20px' }}>
                        <Link to="/hospitalregister" style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }}>If you want register as hospital? Click Here</Link>
                    </div>

                    <div style={{ textAlign: 'left', marginTop: '20px' }}>
                        <Link to="/" style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }}>I already have a membership</Link>
                    </div>

                </div>
            </div>
            <Toast ref={toast} ></Toast>
        </div>
    )
}
